export default __webpack_public_path__ + "static/media/Karela.81e226c9.jpg";